//-----------------------------|| LIST ||---------------------------------------------------------------
export const SET_REGION_LIST = 'SET_REGION_LIST';
export const CLEAR_REGION_LIST = 'CLEAR_REGION_LIST';
export const REGION_LIST_PENDING = 'REGION_LIST_PENDING';
export const REGION_LIST_ERROR = 'REGION_LIST_ERROR';
export const REGION_LIST_ERROR_CLEAR = 'REGION_LIST_ERROR_CLEAR';

//-----------------------------|| FILTER ||-------------------------------------------------------------
export const REGION_FILTER_DIALOG_OPEN = 'REGION_FILTER_DIALOG_OPEN';
export const REGION_FILTER_DIALOG_CLOSE = 'REGION_FILTER_DIALOG_CLOSE';
export const SET_REGION_FILTER_DATA = 'SET_REGION_FILTER_DATA';

//-----------------------------|| CREATE ||---------------------------------------------------------------
export const REGION_CREATE_DIALOG_OPEN = 'REGION_CREATE_DIALOG_OPEN';
export const REGION_CREATE_DIALOG_CLOSE = 'REGION_CREATE_DIALOG_CLOSE';
export const REGION_CREATE_PENDING = 'REGION_CREATE_PENDING';
export const REGION_CREATE_ERROR = 'REGION_CREATE_ERROR';
export const REGION_CREATE_ERROR_CLEAR = 'REGION_CREATE_ERROR_CLEAR';

//-----------------------------|| EDIT ||---------------------------------------------------------------
export const REGION_EDIT_DIALOG_OPEN = 'REGION_EDIT_DIALOG_OPEN';
export const REGION_EDIT_DIALOG_CLOSE = 'REGION_EDIT_DIALOG_CLOSE';
export const REGION_EDIT_PENDING = 'REGION_EDIT_PENDING';
export const REGION_EDIT_ERROR = 'REGION_EDIT_ERROR';
export const REGION_EDIT_ERROR_CLEAR = 'REGION_EDIT_ERROR_CLEAR';